'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _CurrentArticle = require('./CurrentArticle');

var _CurrentArticle2 = _interopRequireDefault(_CurrentArticle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var withCurrentArticle = function withCurrentArticle() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return function (ComposedComponent) {
        var _options$prop = options.prop,
            propName = _options$prop === undefined ? 'article' : _options$prop;


        var WithCurrentArticle = function WithCurrentArticle(props) {
            return _react2.default.createElement(
                _CurrentArticle2.default,
                null,
                function (value) {
                    return _react2.default.createElement(ComposedComponent, (0, _extends3.default)({}, props, (0, _defineProperty3.default)({}, propName, value)));
                }
            );
        };

        WithCurrentArticle.displayName = 'WithCurrentArticle(' + ComposedComponent.displayName + ')';

        return WithCurrentArticle;
    };
};

exports.default = withCurrentArticle;
//# sourceMappingURL=with-current-article.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/component-context/lib/cjs/with-current-article.js
 ** module id = 479
 ** module chunks = 1
 **/